// extracted by mini-css-extract-plugin
export default {"Container":"TabHeadingItem_Container__7GP83","ActiveTab":"TabHeadingItem_ActiveTab__Qmw2+"};